"use strict";var extend = require("raptor-util/extend");
var inherit = require("raptor-util/inherit");
var VNode = require("./VNode");

function VDocumentFragmentClone(other) {
  extend(this, other);
  this.bZ_ = null;
  this.c__ = null;
}

function VDocumentFragment(out) {
  this.bV_(null /* childCount */);
  this.r_ = out;
}

VDocumentFragment.prototype = {
  bX_: 11,

  ca_: true,

  bP_: function () {
    return new VDocumentFragmentClone(this);
  },

  bo_: function (host) {
    return (host.ownerDocument || host).createDocumentFragment();
  }
};

inherit(VDocumentFragment, VNode);

VDocumentFragmentClone.prototype = VDocumentFragment.prototype;

module.exports = VDocumentFragment;